<ion-header class="landing-header">
  <ion-toolbar class="toolbar" [color]="'primary'">
    <ion-title class="toolbar-title">Activation</ion-title>
  </ion-toolbar>
</ion-header>
<ion-card class="st-activation-card">
  <ion-card-content class="card-content">
    <div class="upper-section">
      <ion-grid class="grid">
        <ion-row>
          <ion-col align-self-center>
            <div>
              <monorepo-zf-icon [iconName]="'activation-logo'"></monorepo-zf-icon>
              <div class="page-title">Activate your app</div>
              <div class="page-subtitle">Please enter the product activation code</div>
            </div>
          </ion-col>
        </ion-row>
      </ion-grid>
    </div>
    <div class="lower-section">
      <form #activationForm="ngForm" (ngSubmit)="handleSubmit()">
        <ion-item class="st-input-wrapper">
          <ion-input
            type="text"
            [(ngModel)]="tokenPostData.token"
            spellcheck="false"
            autocapitalize="off"
            required
            name="token"
            placeholder="Enter Token here"
            maxlength="15"
          ></ion-input>
        </ion-item>
      </form>
      <ion-button
        form="ngForm"
        class="submit-btn"
        [disabled]="!activationForm.valid"
        type="submit"
        (click)="handleSubmit()"
        >Continue
      </ion-button>
      <div class="net-error">
        <p *ngIf="!activationForm.valid && activationForm.touched" color="danger" class="error-msg" padding-left>
          Activation code is required
        </p>
        <ng-container *ngIf="errorMsg">
          <p>{{ printError }}</p>
        </ng-container>
      </div>
    </div>
  </ion-card-content>
</ion-card>
